import TYPES from './types';

export const toggleRealizationLayer = ({ open, clientProfile }) => {
  if(open) {
    return [
      { type: TYPES.toggleLayer, payload: 'realization' },
      { type: TYPES.detailLayer, payload: clientProfile },
    ]
  }

  return [
    { type: TYPES.toggleLayer, payload: null },
    { type: TYPES.detailLayer, payload: null },
  ];
};
